import { getCookie } from 'react-simple-cookie-store'
import { AccessToken } from './AccessToken'

export const getAccessToken = () => {
  try {
    console.log('Getting access token')
    const token = getCookie(AccessToken.Access) || ''

    if (token) {
      // Only show first part of token for security
      const tokenPreview = token.substring(0, 5) + '...'
      console.log('Access token retrieved:', tokenPreview)
    } else {
      console.log('Access token retrieved: not present')
    }

    return token
  } catch (error) {
    console.error('Error getting access token:', error)
    // Log detailed error if available
    if (error instanceof Error) {
      console.error('Error details:', error.message, error.stack)
    }
    return ''
  }
}
